/**
 * kitcond-lock-atc-until-options.js
 * ------------------------------------------------------------
 * Com pick_mode = "no", o tema renderiza o ATC com disabled + "Escolha as opções".
 * Apps (Product Personalizer / Zepto) e o próprio JS do tema removem o `disabled`
 * depois do load, mas deixam o picker com `no-pick`. Este script reaplica o lock
 * enquanto `no-pick` existir — visual e clique, inclusive se o atributo for
 * removido de novo.
 * ------------------------------------------------------------
 */
(function kitcondLockAtcUntilOptions() {
  var LOCK_CLASS = 'is-kitcond-atc-locked';
  var applying = false;

  function closestSection(el) {
    return el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
  }

  function pickerNeedsLock(picker) {
    return !!(picker && picker.hasAttribute('no-pick'));
  }

  function sectionNeedsLock(section) {
    if (!section) return false;
    var pickers = section.querySelectorAll('hdt-variant-picker');
    if (!pickers.length) return false;
    for (var i = 0; i < pickers.length; i++) {
      if (pickerNeedsLock(pickers[i])) return true;
    }
    return false;
  }

  var LOCK_SELECTOR =
    'button.hdt-product-form__submit, button.hdt-sticky-atc__submit, .shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button, .shopify-payment-button__button';

  function collectButtons(section) {
    if (!section) return [];
    var list = [];
    section.querySelectorAll(LOCK_SELECTOR).forEach(function (el) {
      list.push(el);
    });
    return list;
  }

  function canUseDisabledAttr(el) {
    if (!el || !el.matches) return false;
    /* O "Compre já" some se o botão interno ganhar disabled nativo (Shopify aplica --hidden). */
    if (el.matches('.shopify-payment-button__button')) return false;
    return el.matches(
      'button.hdt-product-form__submit, button.hdt-sticky-atc__submit, shopify-accelerated-checkout, shopify-buy-it-now-button'
    );
  }

  function lockEl(el) {
    if (!el) return;
    el.classList.add(LOCK_CLASS);
    el.setAttribute('aria-disabled', 'true');
    if (canUseDisabledAttr(el)) {
      el.disabled = true;
      el.setAttribute('disabled', 'true');
    }
  }

  function unlockEl(el) {
    if (!el || !el.classList.contains(LOCK_CLASS)) return;
    el.classList.remove(LOCK_CLASS);
    el.removeAttribute('aria-disabled');
    if (canUseDisabledAttr(el)) {
      el.removeAttribute('disabled');
      el.disabled = false;
    }
  }

  function syncSection(section) {
    if (!section) return;
    var lock = sectionNeedsLock(section);
    applying = true;
    collectButtons(section).forEach(function (el) {
      if (lock) lockEl(el);
      else unlockEl(el);
    });
    applying = false;
  }

  function syncAll() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(syncSection);
  }

  function pickerForEventTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('hdt-variant-picker');
  }

  function blockIfLocked(event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var hit = t.closest(LOCK_SELECTOR);
    if (!hit) return;
    if (!sectionNeedsLock(closestSection(hit))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', blockIfLocked, true);
  document.addEventListener('pointerdown', blockIfLocked, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    blockIfLocked(event);
  }, true);

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!sectionNeedsLock(closestSection(form))) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var picker = pickerForEventTarget(event.target);
      if (!picker) return;
      requestAnimationFrame(function () {
        syncSection(closestSection(picker));
      });
    },
    true
  );

  if (typeof MutationObserver !== 'undefined') {
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncAll();
      });
    }
    new MutationObserver(function (mutations) {
      if (applying) return;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var node = m.target;
        if (
          m.type === 'attributes' &&
          node &&
          node.classList &&
          node.classList.contains(LOCK_CLASS) &&
          canUseDisabledAttr(node) &&
          sectionNeedsLock(closestSection(node)) &&
          (!node.disabled || node.getAttribute('disabled') !== 'true')
        ) {
          applying = true;
          lockEl(node);
          applying = false;
        }
      }
      schedule();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'no-pick'],
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    syncSection(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
})();
